(function () {
    angular
        .module('app', [
            "ui.router",
            "ngSanitize"
        ])
})();
jQuery.support.cors = true;

